/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Data_Write_Grant_TitleInputs */



/**
* | output |
* | --- |
* | "This app can change your data" |
*
* @param {Canvas_Data_Write_Grant_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_data_write_grant_title = /** @type {((inputs?: Canvas_Data_Write_Grant_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Data_Write_Grant_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese App kann deine Daten ändern")
	return /** @type {LocalizedString} */ ("This app can change your data")
});